import { render, staticRenderFns } from "./HomePrefBlock.vue?vue&type=template&id=6fe01fa0"
import script from "./HomePrefBlock.vue?vue&type=script&lang=js"
export * from "./HomePrefBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports